import React, { useLayoutEffect } from "react";
import { theme } from "../../theme";
import { Text } from "../../Core/Text/Text";
import { Portal } from "@gorhom/portal";
import { Platform, TouchableOpacity, View } from "react-native";
import { styles, ids, getModalStyleSheet } from "./Modal.styles";
import { Icon } from "../../Core/Icon/Icon";
import { Heading } from "../../Core/Heading/Heading";
export const Modal = ({ onClose, heading, subheading, actions, children, color = "light", width = theme.screens.small, styles: userStyles, }) => {
    const { ids: modalIds, styles: modalStyles } = getModalStyleSheet(width, styles[color].backgroundColor);
    useLayoutEffect(() => {
        if (Platform.OS === "web") {
            const originalStyle = window.getComputedStyle(document.body).overflow;
            document.body.style.overflow = "hidden";
            return () => {
                document.body.style.overflow = originalStyle;
            };
        }
        return;
    }, []);
    const PlatformWrapper = Platform.OS === "web"
        ? ({ children }) => (React.createElement("div", { style: {
                ...styles.webContainer,
                position: "fixed",
            } }, children))
        : React.Fragment;
    return (React.createElement(Portal, null,
        React.createElement(PlatformWrapper, null,
            React.createElement(View, { style: styles.overlay, testID: "modal" },
                React.createElement(View, { style: [modalStyles.modal, userStyles], dataSet: { media: modalIds.modal } },
                    typeof heading === "string" ? (React.createElement(Heading, { level: 2, styles: [styles.heading, { color: styles[color].color }] }, heading)) : (heading),
                    typeof subheading === "string" ? (React.createElement(Heading, { level: 4, styles: { color: styles[color].color } }, subheading)) : (subheading),
                    typeof children === "string" ? (React.createElement(Text, { styles: [styles.children, { color: styles[color].color }] }, children)) : (children),
                    actions && (React.createElement(View, { style: styles.actions, dataSet: { media: ids.actions } }, (Array.isArray(actions) ? actions : [actions]).map((action, index) => (React.createElement(View, { key: index, style: styles.action }, action))))),
                    onClose && (React.createElement(TouchableOpacity, { onPress: onClose, style: styles.close, dataSet: { media: ids.close } },
                        React.createElement(Icon.Close, { size: "small", color: color === "greyscale" || color === "brand"
                                ? "light"
                                : "dark" }))))))));
};
//# sourceMappingURL=Modal.js.map